import axios from '@/utils/http.js'

const role = {
    url: {
        get: "/role/get",
        getPage: "/role/getPage",
        add: "/role/add",
        update: "/role/update",
    },
    get: function (params) {
        return axios.get(role.url.get, {
            params: params
        })
    },
    getPage: function (params) {
        return axios.get(role.url.getPage, {
            params: params
        })
    },
    add: function (form) {
        return axios.post(role.url.add, form)
    },
    update: function (form) {
        return axios.post(role.url.update, form)
    },
}

export default role